<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="district.districtID ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :model="district" :rules="ruleValidate" label-width="80px">
      <el-form-item label="区域名称" prop="districtName">
        <el-input v-model="district.districtName" placeholder="请输入区域名称"/>
      </el-form-item>
      <el-form-item label="上级区域">
        <el-input v-model="district.parentName" readonly placeholder="请选择上级区域">
          <el-button slot="append" icon="el-icon-search" @click="$refs.districtSelect.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="district.note" type="textarea" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
    <district-select ref="districtSelect" @select="districtSelect"/>
  </el-dialog>
</template>

<script>
  import DistrictSelect from "./DistrictSelect.vue";
  export default {
    components: { DistrictSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        district: {
          districtID: 0,
          districtName: "",
          parentID: "",
          parentName: "",
          note: "",
        },
        ruleValidate: {
          districtName: { required: true, message: "请输入区域名称", trigger: "blur" },
        },
      };
    },

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.district = Object.assign(this.district, row);
        }
      },

      // 提交
      submitHandle() {
        if (!this.district.districtID) {
          this.addHandle();
        } else {
          this.editHandle();
        }
      },

      // 选择上级区域
      districtSelect(row) {
        this.district.parentName = row.districtName;
        this.district.parentID = row.districtId;
      },

      // 新建
      addHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "districts", this.district)
              .then((resp) => {
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 编辑
      editHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "districts", this.district)
              .then((resp) => {
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                }
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
